import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d516524"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "multiple"]
const _hoisted_2 = {
  key: 0,
  class: "inputBox__append-icon"
}
const _hoisted_3 = {
  key: 2,
  class: "inputBox__error"
}
const _hoisted_4 = {
  key: 0,
  class: "inputBox__file-link mt--5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "hoverUnderline" }, "Прикрепленные файлы", -1))
const _hoisted_6 = {
  key: 0,
  class: "fileInputBox__popup-menu"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "fileInputBox__popup-menu"
}
const _hoisted_9 = { class: "fileInputBox__popup-menu-item" }
const _hoisted_10 = ["href"]

import { computed, getCurrentInstance, ref } from 'vue';
import { FileType, StylesType } from '@/types';
import { ComponentInternalInstance } from '@vue/runtime-core';
import { prepareUrl } from '@/utils/Common/Common';

// eslint-disable-next-line no-undef
type Event<T = EventTarget> = {
  target: T;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFileInput',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    btnText: { default: 'Загрузить' },
    styleType: { default: undefined },
    styles: {},
    height: { default: '36' },
    withIcon: { type: Boolean },
    multiple: { type: Boolean },
    files: {},
    error: {},
    withDeleteFile: { type: Boolean, default: true },
    withBg: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['focus', 'deleteFile'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const inputValue = _useModel<FileList | null>(__props, "modelValue");
const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

const props = __props;

const emit = __emit;

const isError = ref(false);

const getLink = (file: FileType): string | null => {
  if (file?.path?.includes('http')) {
    return file?.path;
  }
  if (file?.path) {
    return prepareUrl(file.path) as string;
  }

  return null;
};

const cssProps = computed(() => {
  return {
    '--border': props.styles?.border,
    '--background-color': props.styles?.backgroundColor,
    '--min-height': `${props.height}px`,
  };
});

const fileInputClick = () => {
  emit('focus');
  const fileInput = document.getElementById(`fileInput${uuid.value}`);

  if (fileInput) {
    fileInput.click();
  }
};

const textValue = ref('');

const updateValue = (val: Event) => {
  inputValue.value = val.target.files;
  if (val.target.files) {
    textValue.value = Object.values(val.target.files)
      ?.map(el => el.name)
      .join(' ');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_popup = _resolveComponent("base-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([{ styleType: _ctx.styleType, withText: !_ctx.withIcon }, "fileInputBox"]),
      style: _normalizeStyle([cssProps.value])
    }, [
      _createVNode(_component_base_input, {
        id: "txt",
        class: _normalizeClass([{ paddingRight: _ctx.withIcon }, "attach_file"]),
        label: _ctx.label,
        "model-value": textValue.value,
        styleType: _ctx.styleType,
        "with-bg": _ctx.withBg,
        type: "text",
        withoutFocus: "",
        onClick: fileInputClick
      }, null, 8, ["class", "label", "model-value", "styleType", "with-bg"]),
      _createElementVNode("input", {
        id: `fileInput${uuid.value}`,
        class: _normalizeClass([{ paddingRight: _ctx.withIcon }, "hidden fileInputBox__hidden-input"]),
        multiple: _ctx.multiple,
        type: "file",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (updateValue($event)))
      }, null, 42, _hoisted_1),
      (_ctx.withIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_base_icon, {
              height: _ctx.height,
              clickable: "",
              color: "#94857d",
              name: "attach_file",
              width: "21",
              onClick: fileInputClick
            }, null, 8, ["height"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.withIcon)
        ? (_openBlock(), _createBlock(_component_base_button, {
            key: 1,
            text: _ctx.btnText,
            class: "fileInputBox__btn",
            height: "36",
            "style-type": "greenBorder",
            width: "162",
            onClick: fileInputClick
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (isError.value || _ctx.error?.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ], 6),
    (_ctx.files && (Array.isArray(_ctx.files) ? _ctx.files.length : true))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_base_popup, {
            "show-close-icons": false,
            start: ""
          }, {
            content: _withCtx(() => [
              (Array.isArray(_ctx.files))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fileInputBox__popup-menu-item"
                      }, [
                        _createElementVNode("a", {
                          href: getLink(file),
                          target: "_blank"
                        }, _toDisplayString(file.name), 9, _hoisted_7),
                        (_ctx.withDeleteFile)
                          ? (_openBlock(), _createBlock(_component_base_icon, {
                              key: 0,
                              clickable: "",
                              color: "black",
                              "font-size": "16",
                              height: "10",
                              name: "close",
                              width: "10",
                              onClick: ($event: any) => (_ctx.$emit('deleteFile', file.id))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("a", {
                        href: getLink(_ctx.files as FileType),
                        target: "_blank"
                      }, _toDisplayString((_ctx.files as FileType).name), 9, _hoisted_10),
                      (_ctx.withDeleteFile)
                        ? (_openBlock(), _createBlock(_component_base_icon, {
                            key: 0,
                            clickable: "",
                            color: "black",
                            "font-size": "16",
                            height: "10",
                            name: "close",
                            width: "10",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deleteFile', (_ctx.files as FileType).id)))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ]),
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})